import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Footer from './Footer';
import Sidebar from './Sidebar';
import OfferForm from './OfferForm';
import Lenders from './Lenders';
import Listings from './Listings';
import ListingDetail from './ListingDetail';
import OffersTable from './OffersTable';
import OfferDetail from './OfferDetail';
import MySubmissions from './MySubmissions';
import PendingLenders from './PendingLenders';
import SeedDatabase from './SeedDatabase';
import FAQ from './FAQ';
import ContactUs from './ContactUs';
import AdminSettings from './AdminSettings';
import AdminManualReview from './AdminManualReview';
import ManualOfferEntry from './ManualOfferEntry';
import UserMenu from './UserMenu';
import { Offer } from '../types';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedOffer, setSelectedOffer] = useState<Offer | null>(null);

  return (
    <div className="dashboard">
      <div className="dashboard-container">
        <Sidebar onSelectOffer={setSelectedOffer} />
        
        <div className="dashboard-content">
          <UserMenu />
          
          <main className="dashboard-main">
          <Routes>
            <Route path="/" element={<Listings />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/listings/:listingId" element={<ListingDetail />} />
            <Route path="/submit-offer" element={<OfferForm />} />
            <Route path="/submit-offer/:listingId" element={<OfferForm />} />
            <Route path="/lenders" element={<Lenders />} />
            <Route path="/pending-lenders" element={<PendingLenders />} />
            <Route path="/offers" element={<OffersTable />} />
            <Route path="/offers/:id" element={<OfferDetail />} />
            <Route path="/my-submissions" element={<MySubmissions />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/admin-settings" element={<AdminSettings />} />
            <Route path="/review-queue" element={<AdminManualReview />} />
            <Route path="/review-queue/:offerId" element={<ManualOfferEntry />} />
            <Route path="/seed" element={<SeedDatabase />} />
          </Routes>
        </main>
      </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Dashboard;
